export const API_REQUEST = '[app] API Request';
export const API_REQUEST2 = '[app] API Request2';

export const apiRequest = (body, meta) => ({
  type: API_REQUEST,
  payload: body,
  meta: meta,
});

// export const apiRequest2 = (body, meta) => ({
//   type: API_REQUEST2,
//   payload: body,
//   meta: meta,
// });

